import { Pipe, PipeTransform } from "@angular/core";
import { ChapterDto, ChallengeDto, StepDto, LearningModuleDto } from "@api";

@Pipe({ name: "learningModulesDefaultImage" })
export class LearningModulesDefaultImagePipe implements PipeTransform {
  public transform(learningModule: LearningModuleDto, chapter?: ChapterDto, challenge?: ChallengeDto, step?: StepDto): string {
    if (step?.imageUrl) return step.imageUrl;
    if (chapter?.imageUrl) return chapter.imageUrl;
    if (challenge?.imageUrl) return challenge.imageUrl;
    if (learningModule?.imageUrl) return learningModule.imageUrl;

    return `https://via.placeholder.com/200/${learningModule?.color?.slice(1) || "F2F2F2"}?text=%20`;
  }
}
